<template>
  <div class="container">
    <van-swipe :autoplay="4000" class="carousel" height="45vw" :duration="500">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img :src="image" />
      </van-swipe-item>
    </van-swipe>
    <form action="/">
      <van-search
        v-model="search"
        placeholder="请输入搜索关键词"
        @search="onSearch"
      />
    </form>
    <van-list
      v-model="loading"
      :immediate-check="false"
      :finished="finished"
      finished-text="没有更多啦"
      @load="load_more"
    >
      <div class="main" v-for="item in list" :key="item.id" @click="urlchange(item.id)">
        <div class="left">
          <img :src="item.img" alt="">
        </div>
        <div class="right">
          <div>
            <p class="name">{{item.name}}</p>
            <p class="intro" v-html="item.intro"></p>
          </div>
          <div>
            <p class="bottom"><span class="red">所在地址：</span>{{item.address}}</p>
            <p class="bottom"><span class="red">联系方式：</span>{{item.contact_mobile}}</p>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name:'sjzd',
  data() {
    return {
      images:[
        'static/img/banner3.png',
        'static/img/banner3.png'
      ],
      list:[],
      loading:false,
      finished:false,
      page: 1,
      limit: 20,
      search:'',
      isall:true,
    }
  },
  created(){
    this.$axios({
      method:'post',
      url:'/api/org/sj_list',
      data:this.qs.stringify({
        token:sessionStorage.getItem('wmtoken')
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.list = res.data.data.list;
      }
    })
  },
  methods:{
    urlchange(id){
      this.$router.push({
        name:'sjdetail',
        query:{
          id:id
        }
      });
    },
    load_more(){
      this.page += 1;//页数+1
      this.onLoad();
    },
    onLoad(){
      var that = this;
      if(this.isall){
        setTimeout(function(){
          that.$axios({
            method:'post',
            url:'/api/org/sj_list',
            data:that.qs.stringify({
              token:sessionStorage.getItem('wmtoken'),
              page:that.page,
            })
          }).then(res => {
            console.log(res.data);
            if(res.data.code == 0){
              that.list = that.list.concat(res.data.data.list); 
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {  //数据全部加载完成
              that.finished = true;
            }else{
              that.finished = false;
            }
          })
        },500)
      }else{
        this.loading = false;
        this.finished = true;
      }
    },
    onSearch(val){
      if(val == ''){
        this.isall = true;
        this.finished = false;
        this.$axios({
          method:'post',
          url:'/api/org/sj_list',
          data:this.qs.stringify({
            token:sessionStorage.getItem('wmtoken')
          })
        }).then(res => {
          console.log(res.data);
          if(res.data.code == 0){
            this.list = res.data.data.list;
          }else{
            this.$toast(res.data.msg);
          }
        })
      }else{
        this.isall = false;
        this.$axios({
          method:'post',
          url:'/api/index/search',
          data:this.qs.stringify({
            keyword:val,
            mod:'org_sj',
          })
        }).then(res => {
          console.log(res.data);
          if(res.data.code == 0){
            this.list = res.data.data.sj_org_list;
          }else{
            this.$toast(res.data.msg);
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.container{
  background: #F2F2F2;
  min-height: 100vh;
}
img{
  width: 100%;
  display: block;
}
.carousel img{
  height: 100%;
}
.main{
  display: flex;
  background: white;
  padding: 10px;
  margin: 10px;
}
.left img{
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 5px;
}
.left{
  width: 35vw;
  height: 25vw;
  margin-right: 5px;
}
.right{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 62%;
}
.red{
  color: red;
}
.bottom{
  font-size: 14px;
}
.name{
  font-weight: bold;
}
.intro{
  color: grey;
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/sjzd.vue